import { routes as definePaymentRoutes } from "./define-payment/routes";
import { routes as paymentRoutes } from "./payment/routes";
import { routes as viewPaymentRoutes } from "./view-payments/routes";
import { routes as reversePaymentRoutes } from "./reverse-payment/routes";
export const routes = (prefix = `billing`, pref = `consultant-dashboard`) => [
    {
        path: `/${prefix}/${pref}`,
        name: `${prefix}.${pref}.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pref}.index`,
                PageDescription: "Accounts: Consultant Payment Dashboard",
            },
        },
    },
    ...definePaymentRoutes(prefix, pref),
    ...paymentRoutes(prefix, pref),
    ...viewPaymentRoutes(prefix, pref),
    ...reversePaymentRoutes(prefix, pref),
];